<app-back-button />
<div class="page-header">
  <div class="left-area">
    <span class="title">Vagas</span>
    <span class="sub-title">Consulte as vagas de emprego das empresas do sector</span>
  </div>
  <div class="indicator" *ngIf="vagasCount">
    <div class="icon">
      <img src="icons/img-briefcase.svg" alt="Country Icon" />
    </div>
    <div class="text-bg">
      <span>{{vagasCount}} Vagas abertas</span>
    </div>
  </div>
</div>

<div class="search-bar mb-3">
  <app-search-bar [showPrimaryBtn]="false" [sortFields]="sortFields" (formValueChange)="handleFormValueChange($event)"
    [showFilterBtn]="true" (onFilterBtnClick)="showDialog()"></app-search-bar>
</div>

<div class="row">
  @if (pagination.data?.length) {
  <app-table [pagination]="pagination" [columns]="columns" [actions]="accoes" (pageChange)="onPageChange($event)"
    (rowClick)="detalhesVaga($event)"></app-table>
  } @else {
  <div class="no-data">
    <app-data-void titulo="Nehuma vaga encontrada"
      descricao="Quando forem criadas vagas, ela aparecerão aqui"></app-data-void>
  </div>
  }

</div>

<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue" class="w-full">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />

      <!-- Se for Data -->
      <p-datepicker *ngIf="filter.type === 'date'" [formControlName]="filter.controlName" [minDate]="minDate"
        [maxDate]="maxDate" [placeholder]="filter.placeholder" appendTo="body" class="w-full" dateFormat="dd.mm.yy"
        showIcon iconDisplay="input" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>

<p-toast></p-toast>